var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsultation1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3571_41682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.11111 9H7.66667V10.5556H6.11111V9ZM17 5.11111V16C17 16.8556 16.3 17.5556 15.4444 17.5556H4.55556C3.69222 17.5556 3 16.8556 3 16L3.00778 5.11111C3.00778 4.25556 3.69222 3.55556 4.55556 3.55556H5.33333V2H6.88889V3.55556H13.1111V2H14.6667V3.55556H15.4444C16.3 3.55556 17 4.25556 17 5.11111ZM4.55556 6.66667H15.4444V5.11111H4.55556V6.66667ZM15.4444 16V8.22222H4.55556V16H15.4444ZM12.3333 10.5556H13.8889V9H12.3333V10.5556ZM9.22222 10.5556H10.7778V9H9.22222V10.5556Z",
    fill: "#99D7D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3571_41682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultation1);
export default __webpack_public_path__ + "static/media/consultation1.365d9f60fcebecd7fa022400584b3275.svg";
export { ForwardRef as ReactComponent };